module.exports = __webpack_public_path__ + "media/PAG76-03.5cec9dff.mp3";